import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import tamga from '../../../assets/images/tamga.png'
import * as html2pdf from 'html2pdf.js'
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


const ReportBox2_2 = () => {

  const [k21Value, setK21Value] = useState('');
  const [k22Value, setK22Value] = useState('');
  const [k23Value, setK23Value] = useState('');
  const [k24Value, setK24Value] = useState('');
  const [k25Value, setK25Value] = useState('');
  const [k26Value, setK26Value] = useState('');
  const [k27Value, setK27Value] = useState('');
  const [k28Value, setK28Value] = useState('');
  const [k29Value, setK29Value] = useState('');
  const [k30Value, setK30Value] = useState('');
  const [k31Value, setK31Value] = useState('');
  const [k32Value, setK32Value] = useState('');
  const [k33Value, setK33Value] = useState('');
  const [k34Value, setK34Value] = useState('');
  const [k35Value, setK35Value] = useState('');
  const [k36Value, setK36Value] = useState('');
  const [k37Value, setK37Value] = useState('');
  const [k38Value, setK38Value] = useState('');
  const [k39Value, setK39Value] = useState('');
  const [k40Value, setK40Value] = useState('');
  const [k41Value, setK41Value] = useState('');
  const [k42Value, setK42Value] = useState('');
  const [k43Value, setK43Value] = useState('');
  const [k44Value, setK44Value] = useState('');
  const [k45Value, setK45Value] = useState('');
  const [k46Value, setK46Value] = useState('');
  const [k47Value, setK47Value] = useState('');
  const [k48Value, setK48Value] = useState('');
  const [k49Value, setK49Value] = useState('');
  const [k50Value, setK50Value] = useState('');
  const [k51Value, setK51Value] = useState('');
  const [k52Value, setK52Value] = useState('');
  const [k53Value, setK53Value] = useState('');
  const [k54Value, setK54Value] = useState('');


  const [l21Value, setL21Value] = useState('');
  const [l22Value, setL22Value] = useState('');
  const [l23Value, setL23Value] = useState('');
  const [l24Value, setL24Value] = useState('');
  const [l25Value, setL25Value] = useState('');
  const [l26Value, setL26Value] = useState('');
  const [l27Value, setL27Value] = useState('');
  const [l28Value, setL28Value] = useState('');
  const [l29Value, setL29Value] = useState('');
  const [l30Value, setL30Value] = useState('');
  const [l31Value, setL31Value] = useState('');
  const [l32Value, setL32Value] = useState('');
  const [l33Value, setL33Value] = useState('');
  const [l34Value, setL34Value] = useState('');
  const [l35Value, setL35Value] = useState('');
  const [l36Value, setL36Value] = useState('');
  const [l37Value, setL37Value] = useState('');
  const [l38Value, setL38Value] = useState('');
  const [l39Value, setL39Value] = useState('');
  const [l40Value, setL40Value] = useState('');
  const [l41Value, setL41Value] = useState('');
  const [l42Value, setL42Value] = useState('');
  const [l43Value, setL43Value] = useState('');
  const [l44Value, setL44Value] = useState('');
  const [l45Value, setL45Value] = useState('');
  const [l46Value, setL46Value] = useState('');
  const [l47Value, setL47Value] = useState('');


  const [m21Value, setM21Value] = useState('');
  const [m22Value, setM22Value] = useState('');
  const [m34Value, setM34Value] = useState('');
  const [m43Value, setM43Value] = useState('');
  const [m44Value, setM44Value] = useState('');
  const [m47Value, setM47Value] = useState('');

  const [n21Value, setN21Value] = useState('');
  const [n22Value, setN22Value] = useState('');
  const [n23Value, setN23Value] = useState('');
  const [n24Value, setN24Value] = useState('');
  const [n25Value, setN25Value] = useState('');
  const [n26Value, setN26Value] = useState('');
  const [n27Value, setN27Value] = useState('');
  const [n28Value, setN28Value] = useState('');
  const [n29Value, setN29Value] = useState('');
  const [n30Value, setN30Value] = useState('');
  const [n31Value, setN31Value] = useState('');
  const [n32Value, setN32Value] = useState('');
  const [n33Value, setN33Value] = useState('');
  const [n34Value, setN34Value] = useState('');
  const [n35Value, setN35Value] = useState('');
  const [n36Value, setN36Value] = useState('');
  const [n37Value, setN37Value] = useState('');
  const [n38Value, setN38Value] = useState('');
  const [n39Value, setN39Value] = useState('');
  const [n40Value, setN40Value] = useState('');
  const [n41Value, setN41Value] = useState('');
  const [n42Value, setN42Value] = useState('');
  const [n43Value, setN43Value] = useState('');
  const [n44Value, setN44Value] = useState('');
  const [n45Value, setN45Value] = useState('');
  const [n46Value, setN46Value] = useState('');
  const [n47Value, setN47Value] = useState('');


  const handleFileRead = async () => {
    const response = await fetch('/report/Report_BOX_2_2.xlsx');
    const arrayBuffer = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    const worksheet = workbook.getWorksheet('З-БОХ-2.2');

    if (worksheet) {

      worksheet.getCell('K21').value = k21Value;
      worksheet.getCell('K22').value = k22Value;
      worksheet.getCell('K23').value = k23Value;
      worksheet.getCell('K24').value = k24Value;
      worksheet.getCell('K25').value = k25Value;
      worksheet.getCell('K26').value = k26Value;
      worksheet.getCell('K27').value = k27Value;
      worksheet.getCell('K28').value = k28Value;
      worksheet.getCell('K29').value = k29Value;
      worksheet.getCell('K30').value = k30Value;
      worksheet.getCell('K31').value = k31Value;
      worksheet.getCell('K32').value = k32Value;
      worksheet.getCell('K33').value = k33Value;
      worksheet.getCell('K34').value = k34Value;
      worksheet.getCell('K35').value = k35Value;
      worksheet.getCell('K36').value = k36Value;
      worksheet.getCell('K37').value = k37Value;
      worksheet.getCell('K38').value = k38Value;
      worksheet.getCell('K39').value = k39Value;
      worksheet.getCell('K40').value = k40Value;
      worksheet.getCell('K41').value = k41Value;
      worksheet.getCell('K42').value = k42Value;
      worksheet.getCell('K43').value = k43Value;
      worksheet.getCell('K44').value = k44Value;
      worksheet.getCell('K45').value = k45Value;
      worksheet.getCell('K46').value = k46Value;
      worksheet.getCell('K47').value = k47Value;
      worksheet.getCell('K48').value = k48Value;
      worksheet.getCell('K49').value = k49Value;
      worksheet.getCell('K50').value = k40Value;
      worksheet.getCell('K51').value = k51Value;
      worksheet.getCell('K52').value = k52Value;
      worksheet.getCell('K53').value = k53Value;
      worksheet.getCell('K54').value = k54Value;


      worksheet.getCell('L21').value = l21Value;
      worksheet.getCell('L22').value = l22Value;
      worksheet.getCell('L23').value = l23Value;
      worksheet.getCell('L24').value = l24Value;
      worksheet.getCell('L25').value = l25Value;
      worksheet.getCell('L26').value = l26Value;
      worksheet.getCell('L27').value = l27Value;
      worksheet.getCell('L28').value = l28Value;
      worksheet.getCell('L29').value = l29Value;
      worksheet.getCell('L30').value = l30Value;
      worksheet.getCell('L31').value = l31Value;
      worksheet.getCell('L32').value = l32Value;
      worksheet.getCell('L33').value = l33Value;
      worksheet.getCell('L34').value = l34Value;
      worksheet.getCell('L35').value = l35Value;
      worksheet.getCell('L36').value = l36Value;
      worksheet.getCell('L37').value = l37Value;
      worksheet.getCell('L38').value = l38Value;
      worksheet.getCell('L39').value = l39Value;
      worksheet.getCell('L40').value = l40Value;
      worksheet.getCell('L41').value = l41Value;
      worksheet.getCell('L42').value = l42Value;
      worksheet.getCell('L43').value = l43Value;
      worksheet.getCell('L44').value = l44Value;
      worksheet.getCell('L45').value = l45Value;
      worksheet.getCell('L46').value = l46Value;
      worksheet.getCell('L47').value = l47Value;


      worksheet.getCell('M21').value = m21Value;
      worksheet.getCell('M22').value = m22Value;
      worksheet.getCell('M34').value = m34Value;
      worksheet.getCell('M43').value = m43Value;
      worksheet.getCell('M44').value = m44Value;
      worksheet.getCell('M47').value = m47Value;

      worksheet.getCell('N21').value = n21Value;
      worksheet.getCell('N22').value = n22Value;
      worksheet.getCell('N23').value = n23Value;
      worksheet.getCell('N24').value = n24Value;
      worksheet.getCell('N25').value = n25Value;
      worksheet.getCell('N26').value = n26Value;
      worksheet.getCell('N27').value = n27Value;
      worksheet.getCell('N28').value = n28Value;
      worksheet.getCell('N29').value = n29Value;
      worksheet.getCell('N30').value = n30Value;
      worksheet.getCell('N31').value = n31Value;
      worksheet.getCell('N32').value = n32Value;
      worksheet.getCell('N33').value = n33Value;
      worksheet.getCell('N34').value = n34Value;
      worksheet.getCell('N35').value = n35Value;
      worksheet.getCell('N36').value = n36Value;
      worksheet.getCell('N37').value = n37Value;
      worksheet.getCell('N38').value = n38Value;
      worksheet.getCell('N39').value = n39Value;
      worksheet.getCell('N40').value = n40Value;
      worksheet.getCell('N41').value = n41Value;
      worksheet.getCell('N42').value = n42Value;
      worksheet.getCell('N43').value = n43Value;
      worksheet.getCell('N44').value = n44Value;
      worksheet.getCell('N45').value = n45Value;
      worksheet.getCell('N46').value = n46Value;
      worksheet.getCell('N47').value = n47Value;


      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'Report_BOX_2_2.xlsx');
    } else {
      console.error('Worksheet not found');
    }
  };

  const exportToPDF = () => {
    const element = document.getElementById('exportable-content');

    if (element) {
      const opt = {
        margin: 0.5,
        filename: 'Бох-2_3-тайлан.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'p' }
      };

      // html2pdf ашиглан PDF болгон хувиргана
      html2pdf().from(element).set(opt).save();
    } else {
      console.error('Element not found!');
    }
  };

  document.title = "БОХ-2.2 маягт. Усны ашиглалтын 20... жилийн мэдээ ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Тайлан" breadcrumbItem="БОХ-2.2 маягт" />
          <div className="d-flex flex-column mx-auto reportBox" style={{ width: '800px' }}>
            <Card>
              <CardBody className="border-bottom">
                <div id="exportable-content">
                  <Row>
                    <div className="d-flex align-content-between ">
                      <img className="tamga" src={tamga} alt="" />
                      <Col lg={6}>
                        <p style={{ textAlign: 'justify', width: '350px', fontSize: '10px' }}>
                          Үндэсний статистикийн хорооны даргын 2019 оын А/134 дүгээр тушаалаар зөвшөөрснөөр, Байгаль орчин, аялал жуулчлалын сайдын 2019 оны 09 сарын 19 - ны өдрийн А/527 дугаар тушаалаар батлав.
                        </p>
                      </Col>
                      <Col lg={6}>
                        <p style={{ textAlign: 'right', fontSize: '10px' }}>З-БОХ-2.1</p>
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <CardTitle className="text-center text-uppercase" style={{ fontSize: '12px' }}> усны нөөц, хомсдол, хамгааллын 2024 оны жилийн мэдээ </CardTitle>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 1. Хаягийн хэсэг </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={5}>
                      <div>
                        <table className="table table-bordered border-dark tableTopLeftCenter">
                          <thead>
                            <tr>
                              <th style={{ width: '200px', padding: '0' }}> Байршил </th>
                              <th style={{ width: '250px', padding: '0' }}> Нэр </th>
                              <th style={{ width: '100px', padding: '0' }}> Код </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: '0' }}>Аймаг, нийслэл</td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                            <tr>
                              <td style={{ padding: '0' }}> Сум, дүүрэг </td>
                              <td style={{ padding: '0' }}>  </td>
                              <td style={{ padding: '0' }}>  </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>

                    <Col lg={7}>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        1. Сум, дүүргийн байгаль орчны асуудал хариуцсан мэргэжилтэн нь мэдээг дараа оны 2 дугаар сарын 01-ны дотор аймаг, нийслэлийн байгаль орчны асуудал эрхэлсэн газарт цахимаар болон маягтаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        2. Аймаг, нийслэлийн байгаль орчны асуудал эрхэлсэн газар нь мэдээг хянаж, нэгтгээд 2 дугаар сарын 15-ны дотор Байгаль орчны мэдээллийн төвд цахим хэлбэрээр ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        3. Байгаль орчны мэдээллийн төв нь мэдээг хянаад 2 дугаар сарын 25-ны дотор байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын усны асуудал хариуцсан нэгжид цахим хэлбэрэр ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        4. Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын усны асуудал хариуцсан нэгж нь мэдээг хянаж, нэгтгээд 3 дугаар сарын 10-ны дотор статистик хариуцсан нэгжид цахимаар болон маягтаар ирүүлнэ.
                      </p>
                      <p style={{ textAlign: 'justify', fontSize: '10px' }} className="p-0 m-0">
                        5. Байгаль орчны асуудал эрхэлсэн төрийн захиргааны төв байгууллагын статистик хариуцсан нэгж нь мэдээг хянаж 3 дугаар сарын 20-ны дотор Үндэсний статистикийн хороонд цахимаар болон маягтаар ирүүлнэ.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <CardTitle className=" text-uppercase" style={{ fontSize: '12px' }}> 2. Үндсэн үзүүлэлт </CardTitle>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive">
                        <table className="table table-bordered border-dark tableTopLeftCenter">
                          <thead>
                            <tr>
                              <th className="" rowSpan={2} colSpan={11}>Үзүүлэлт</th>
                              <th className="" rowSpan={2}>МД</th>
                              <th className="" rowSpan={2}> Хэмжих нэгж </th>
                              <th className="" rowSpan={2}> Нийт </th>
                              <th className="" rowSpan={1}> Гадаргын уснаас </th>
                              <th className="" rowSpan={1}> Рашааны нөөцөөс </th>
                              <th className="" rowSpan={1}> Газрын доорх уснаас </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={11} className="fw-semibold ">A</td>
                              <td className="">Б</td>
                              <td className="">В</td>
                              <td className="">1</td>
                              <td className="">2</td>
                              <td className="">3</td>
                              <td className="">4</td>
                            </tr>
                            <tr>
                              <td colSpan={11} className="fw-semibold" style={{ textAlign: 'left' }}>Ашигласан усны нийт хэмжээ  мөр1=мөр(2+3+21)</td>
                              <td> 1 </td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k21Value}
                                  onChange={(e) => setK21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l21Value}
                                  onChange={(e) => setL21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m21Value}
                                  onChange={(e) => setM21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n21Value}
                                  onChange={(e) => setN21Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={23} className="nested"></td>
                              <td colSpan={10} className="fw-semibold" style={{ textAlign: 'left' }}>Хүн амын унд, ахуйн хэрэглээнд ашигласан</td>
                              <td>2</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k22Value}
                                  onChange={(e) => setK22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l22Value}
                                  onChange={(e) => setL22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m22Value}
                                  onChange={(e) => setM22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n22Value}
                                  onChange={(e) => setN22Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={10} className="fw-semibold" style={{ textAlign: 'left' }}>Үйлдвэрлэлд ашигласан мөр3=мөр(4+8+9+15+17)</td>
                              <td>3</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k23Value}
                                  onChange={(e) => setK23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l23Value}
                                  onChange={(e) => setL23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n23Value}
                                  onChange={(e) => setN23Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={17} className="nested"></td>
                              <td colSpan={9} className="fw-semibold" style={{ textAlign: 'left' }}>Хөдөө аж ахуйн үйлдвэрлэлд мөр4=мөр(5:7)</td>
                              <td>4</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k24Value}
                                  onChange={(e) => setK24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l24Value}
                                  onChange={(e) => setL24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n24Value}
                                  onChange={(e) => setN24Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={3} className="nested"></td>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Газар тариаланд</td>
                              <td>5</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k25Value}
                                  onChange={(e) => setK25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l25Value}
                                  onChange={(e) => setL25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n25Value}
                                  onChange={(e) => setN25Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Мал ах ахуй</td>
                              <td>6</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k26Value}
                                  onChange={(e) => setK26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l26Value}
                                  onChange={(e) => setL26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n26Value}
                                  onChange={(e) => setN26Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Бусад</td>
                              <td>7</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k27Value}
                                  onChange={(e) => setK27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l27Value}
                                  onChange={(e) => setL27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n27Value}
                                  onChange={(e) => setN27Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={9} className="fw-semibold" style={{ textAlign: 'left' }}>Уул уурхайд </td>
                              <td>8</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k28Value}
                                  onChange={(e) => setK28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l28Value}
                                  onChange={(e) => setL28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n28Value}
                                  onChange={(e) => setN28Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={9} className="fw-semibold" style={{ textAlign: 'left' }}>Боловсруулах үйлдвэрлэлд мөр9=мөр(10:14)</td>
                              <td>9</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k29Value}
                                  onChange={(e) => setK29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l29Value}
                                  onChange={(e) => setL29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n29Value}
                                  onChange={(e) => setN29Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={5} className="nested"></td>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Хүнсний үйлдвэрлэлд</td>
                              <td>10</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k30Value}
                                  onChange={(e) => setK30Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l30Value}
                                  onChange={(e) => setL30Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n30Value}
                                  onChange={(e) => setN30Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Архи, пиво, ундааны үйлдвэрлэлд</td>
                              <td>11</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k31Value}
                                  onChange={(e) => setK31Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l31Value}
                                  onChange={(e) => setL31Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n31Value}
                                  onChange={(e) => setN31Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Арьс, арьсан бүтээгдэхүүн үйлдвэрлэлд</td>
                              <td>12</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k32Value}
                                  onChange={(e) => setK32Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l32Value}
                                  onChange={(e) => setL32Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n32Value}
                                  onChange={(e) => setN32Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Барилгын материалын үйлдвэрлэлд</td>
                              <td>13</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k33Value}
                                  onChange={(e) => setK33Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l33Value}
                                  onChange={(e) => setL33Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n33Value}
                                  onChange={(e) => setN33Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Бусад</td>
                              <td>14</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k34Value}
                                  onChange={(e) => setK34Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l34Value}
                                  onChange={(e) => setL34Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m34Value}
                                  onChange={(e) => setM34Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n34Value}
                                  onChange={(e) => setN34Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={9} className="fw-semibold" style={{ textAlign: 'left' }}>Эрчим хүчний үйлдвэрлэлд мөр15≥мөр16</td>
                              <td>15</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k35Value}
                                  onChange={(e) => setK35Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l35Value}
                                  onChange={(e) => setL35Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n35Value}
                                  onChange={(e) => setN35Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={1} className="nested"></td>
                              <td colSpan={8} style={{ textAlign: 'left' }}>Усан цахилгаан станцад </td>
                              <td>16</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k36Value}
                                  onChange={(e) => setK36Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l36Value}
                                  onChange={(e) => setL36Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n36Value}
                                  onChange={(e) => setN36Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={9} className="fw-semibold" style={{ textAlign: 'left' }}>Барилгын салбарт мөр17=мөр(18:20)</td>
                              <td>17</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k37Value}
                                  onChange={(e) => setK37Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l37Value}
                                  onChange={(e) => setL37Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n37Value}
                                  onChange={(e) => setN37Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={3} className="nested"></td>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Барилга угсралтад </td>
                              <td>18</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k38Value}
                                  onChange={(e) => setK38Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l38Value}
                                  onChange={(e) => setL38Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n38Value}
                                  onChange={(e) => setN38Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Төмөр зам болон авто замын барилга байгууламж барихад </td>
                              <td>19</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k39Value}
                                  onChange={(e) => setK39Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l39Value}
                                  onChange={(e) => setL39Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n39Value}
                                  onChange={(e) => setN39Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Бусад </td>
                              <td>20</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k40Value}
                                  onChange={(e) => setK40Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l40Value}
                                  onChange={(e) => setL40Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n40Value}
                                  onChange={(e) => setN40Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={10} className="fw-semibold" style={{ textAlign: 'left' }}>Үйлчилгээнд ашигласан мөр21=мөр(22+23)</td>
                              <td>21</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k41Value}
                                  onChange={(e) => setK41Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l41Value}
                                  onChange={(e) => setL41Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n41Value}
                                  onChange={(e) => setN41Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={3} className="nested"></td>
                              <td colSpan={9} style={{ textAlign: 'left' }}> Төрийн байгууллага </td>
                              <td>22</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k42Value}
                                  onChange={(e) => setK42Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l42Value}
                                  onChange={(e) => setL42Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n42Value}
                                  onChange={(e) => setN42Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={9} style={{ textAlign: 'left' }}> Аж ахуйн нэгж, байгууллага мөр23≥мөр24 </td>
                              <td>23</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k43Value}
                                  onChange={(e) => setK43Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l43Value}
                                  onChange={(e) => setL43Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m43Value}
                                  onChange={(e) => setM43Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n43Value}
                                  onChange={(e) => setN43Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td rowSpan={1} className="nested"></td>
                              <td colSpan={8} style={{ textAlign: 'left' }}> Аялал жуулчлалын  </td>
                              <td>24</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k44Value}
                                  onChange={(e) => setK44Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l44Value}
                                  onChange={(e) => setL44Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m44Value}
                                  onChange={(e) => setM44Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>

                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n44Value}
                                  onChange={(e) => setN44Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={11} style={{ textAlign: 'left' }}> Дахин ашигласан усны хэмжээ  </td>
                              <td>25</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k45Value}
                                  onChange={(e) => setK45Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l45Value}
                                  onChange={(e) => setL45Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n45Value}
                                  onChange={(e) => setN45Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={11} style={{ textAlign: 'left' }}> Эргүүлэн ашигласан усны хэмжээ </td>
                              <td>26</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k46Value}
                                  onChange={(e) => setK46Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l46Value}
                                  onChange={(e) => setL46Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n46Value}
                                  onChange={(e) => setN46Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={11} style={{ textAlign: 'left' }}> Ус, рашааны нөөц ашигласны төлбөрийн орлого </td>
                              <td>27</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k47Value}
                                  onChange={(e) => setK47Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={l47Value}
                                  onChange={(e) => setL47Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={m47Value}
                                  onChange={(e) => setM47Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>

                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={n47Value}
                                  onChange={(e) => setN47Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={11} style={{ textAlign: 'left' }}> Усны нөөц, чанарыг хамгаалах, нөхөн сэргээх арга хэмжээнд зарцуулсан зардал мөр28=мөр(29:34) </td>
                              <td>28</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k48Value}
                                  onChange={(e) => setK48Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>X  </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td rowSpan={6}></td>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Улсын төсвөөс </td>
                              <td>29</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k49Value}
                                  onChange={(e) => setK49Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td> X </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Орон нутгийн төсвөөс </td>
                              <td>30</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k50Value}
                                  onChange={(e) => setK50Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>X  </td>
                              <td> X </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Зээл, тусламж </td>
                              <td>31</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k51Value}
                                  onChange={(e) => setK51Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td> X </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Хөгжлийн албан ёсны тусламж </td>
                              <td>32</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k52Value}
                                  onChange={(e) => setK52Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td>X  </td>
                              <td> X </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Хувийн хэвшлээс </td>
                              <td>33</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k53Value}
                                  onChange={(e) => setK53Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>X  </td>
                              <td> X </td>
                            </tr>
                            <tr>
                              <td colSpan={10} style={{ textAlign: 'left' }}> Бусад эх үүсвэрээс </td>
                              <td>34</td>
                              <td> мян.м3 </td>
                              <td>
                                <input
                                  className='reportBoxField'
                                  type="text"
                                  value={k54Value}
                                  onChange={(e) => setK54Value(e.target.value)}
                                  placeholder="Утга оруулах . . ." />
                              </td>
                              <td> X </td>
                              <td>X  </td>
                              <td> X </td>
                            </tr>


                          </tbody>
                        </table>
                      </div>

                    </Col>
                  </Row>
                </div>
                <Row>
                  <Col className="d-flex justify-content-evenly">
                    <button onClick={exportToPDF}
                      type="button"
                      className="btn btn-primary  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      PDF Татах
                    </button>


                    <button onClick={handleFileRead}
                      type="button"
                      className="btn btn-success  btn-label"
                    >
                      <i className="mdi mdi-download label-icon"></i>{" "}
                      Excel Татах
                    </button>

                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default ReportBox2_2;